<template>
  <section class="content-generator">
    <template v-for="(section, index) in content">
      <component :is="section.component" :key="index" v-bind="section.fields" />
    </template>
  </section>
</template>

<script>
import PageHeader from '@/sections/page-header/PageHeader.vue'
import Hero from '@/sections/section-header/SectionHeader.vue'
import Heading from '@/components/heading/Heading.vue'
import Wysiwyg from '@/components/wysiwyg/Wysiwyg.vue'
import Button from '@/components/partials/Button.vue'
import News from '@/sections/section-news/SectionNews.vue'
import Cards from '@/sections/cards/Cards.vue'
import Accordions from '@/sections/accordions/Accordions.vue'
import InfoCards from '@/sections/section-needtoknow/SectionNeedtoknow.vue'
import Upsells from '@/sections/upsells/Upsells.vue'
import SectionTablelinks from '@/sections/section-tablelinks/SectionTablelinks.vue'
import SectionTable from '@/sections/section-table/SectionTable.vue'
import Buttons from '@/components/buttons/Buttons.vue'

export default {
  components: {
    PageHeader,
    Hero,
    Heading,
    Wysiwyg,
    Button,
    News,
    Cards,
    InfoCards,
    Accordions,
    Upsells,
    SectionTablelinks,
    SectionTable,
    Buttons
  },
  props: {
    content: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.content-generator {
  & > .button {
    width: calc(100% - #{$padding} * 2);
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
